import React from 'react'
import BatchConvertContainer from '../components/batchConvert.container';

const BatchConvertPage: React.FC = () => {
  return(
    <div className="h-full">
      <BatchConvertContainer />
    </div>
  )
}

export default BatchConvertPage;